import VueMonthlyPicker from 'vue-monthly-picker';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
import CONFIG from "@/assets/js/config.js";
import axios from 'axios';
import store from '@/store';
import ValidationService from '@/services/ValidationService';

export default {
	name: "payslipList",
	components: {
		MainLayout,
		Loading,
		CONFIG,
		VueMonthlyPicker,
		AdvancedLaravelVuePaginate,
		Select2Multiple,
	},

	mixins: [ValidationService],

	data() {
		return {
			payslipData: {},
			campusId: store.state.user.campus_id,
			noDataMsg: CONFIG.NO_DATA_FOUND,
			isLoading: false,
			searchData: {},
            statusArr: CONFIG.EMP_PAYMENT_STATUS,
			currentYearId: '',
			isSearch: 0,
			empTypeArr: CONFIG.EMPLOYEE_TYPE_CLASS,
			totalPaidAmount: 0,
			search_status: false,
			searchedData: null,
			isSearched: false,
			payslipIds: [],
			checkAll: false,
			selectedPayslipIds: [],
			approveStatus: CONFIG.EMP_PAYMENT_STATUS_ID.APPROVE,
			rejectStatus: CONFIG.EMP_PAYMENT_STATUS_ID.REJECT,
			paidStatus: CONFIG.EMP_PAYMENT_STATUS_ID.PAID,
		};
	},

	methods: {
		/**
		 * get list
		 * @param {boolean} isSearch 
		 * @param {int} page 
		 */
		getPayslips(isSearch = 0, page = 1) {
			this.searchData.is_search = isSearch;
			this.clearValidationErrors();
			this.isLoading = true;
			const params = { ...this.searchData };
			if (params.selectedMonth) {
				let month, year;
				if (params.selectedMonth instanceof Date) {
					month = params.selectedMonth.getMonth() + 1;
					year = params.selectedMonth.getFullYear();
				} else if (typeof params.selectedMonth === 'string' && params.selectedMonth.includes('/')) {
					const [m, y] = params.selectedMonth.split('/');
					month = parseInt(m, 10);
					year = parseInt(y, 10);
				} else {
					const d = new Date(params.selectedMonth);
					if (!isNaN(d.getTime())) {
						month = d.getMonth() + 1;
						year = d.getFullYear();
					}
				}
				if (month && year) {
					params.month = month;
					params.year = year;
				}
				delete params.selectedMonth;
			}
			axios.get('payslip/list?page=' + page, {
				params
			})
				.then((res) => {
					if (res.data) {
						this.payslipData = res.data.payslip_data;
						this.payslipIds = res.data.payslip_ids;
						this.isLoading = false;
					}
				}).catch(error => {
					this.printValidationError(error.response);
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
					this.isLoading = false;
				});
		},

		/**
		 * clear search
		 */
		reset() {
			this.searchData = {};
			this.isLoading = true;
			this.getPayslips();
		},

		/**
		 * pdfdownload
		 * @param {Object} payslip 
		 */
		pdfDownload(payslip) {
			this.isLoading = true;
			axios.get(`/payslip/${payslip.id}/pdf-download`, {
				params: {
					campus_id: this.campusId
				},
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/pdf',
				}
			})
			.then((response) => {
				const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
				const fileLink = document.createElement('a');
				fileLink.href = fileURL;
				const fileName = `payslip_${payslip.employee_name}_${payslip.year}${(payslip.month) > 9 ? '' : '0'}${payslip.month}.pdf`;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
				document.body.removeChild(fileLink);
				window.URL.revokeObjectURL(fileURL);
				this.isLoading = false;
			}).catch(error => {
				if (error.response && error.response.status == 401) {
					this.$store.commit('logout');
					window.location.replace('login');
				}
				this.isLoading = false;
			});
		},

		/**
		 * Toggle selection of all payslip checkboxes.
		 *
		 * When checked, copies all ids from payslipIds into selectedPayslipIds;
		 * when unchecked, clears the selection array.
		 *
		 * @param {Event} event Change event from header checkbox
		 */
		selectAll(event) {
			const checked = event.target.checked;
			if (checked) {
				this.selectedPayslipIds = this.payslipIds ? this.payslipIds.slice() : [];
			} else {
				this.selectedPayslipIds = [];
			}
		},

		/**
		 * Toggle a single payslip id in the selected list.
		 *
		 * Adds the id when checkbox is checked and removes it when unchecked.
		 *
		 * @param {Event} event Change event from body checkbox
		 * @param {number} payslipId Employee payment id to toggle
		 */
		toggleSingleCheckbox(event, payslipId) {
			const checked = event.target.checked;
			if (checked) {
				if (!this.selectedPayslipIds.includes(payslipId)) {
					this.selectedPayslipIds.push(payslipId);
				}
			} else {
				this.selectedPayslipIds = this.selectedPayslipIds.filter(id => id !== payslipId);
			}
		},

		/**
		 * Update status (approve / reject / paid) for selected payslips.
		 *
		 * Validates that at least one payslip is selected, resolves the correct
		 * API endpoint based on target status and posts the selected ids. On
		 * success, reloads the list and shows a notification message.
		 *
		 * @param {number} status Target status id (APPROVE, REJECT, PAID)
		 */
		updateStatus(status) {
			if (!this.selectedPayslipIds.length) {
				alert('Please select at least one payslip.');
				return;
			}

			const endpoint = this.getPayslipStatusEndpoint(status);
			if (!endpoint) {
				return;
			}

			const request = {
				emp_payment_ids: this.selectedPayslipIds,
			};

			this.clearValidationErrors();
			this.isLoading = true;
			axios.post(endpoint, request, {
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				this.isLoading = false;
				this.checkAll = false;
				this.selectedPayslipIds = [];

				const isSearch = this.searchData && this.searchData.is_search ? this.searchData.is_search : 0;
				this.getPayslips(isSearch, 1);

				if (response.data && response.data.success && this.$notification) {
					let msg = '';
					if (status === this.approveStatus) {
						msg = 'Payslip approved successfully';
					} else if (status === this.rejectStatus) {
						msg = 'Payslip rejected successfully';
					} else if (status === this.paidStatus) {
						msg = 'Payslip marked as paid successfully';
					}
					if (msg) {
						this.$notification.success(msg, {
							timer: 3,
							position: 'bottomCenter'
						});
					}
				}
			})
			.catch(error => {
				if (error.response && error.response.status === 401) {
					this.$store.commit('logout');
					window.location.replace('login');
				} else if (error.response && error.response.status === 422) {
					this.printValidationError(error.response);
				}
				this.isLoading = false;
			});
		},

		/**
		 * Get API endpoint path for a given payslip status.
		 *
		 * Maps configured status ids to their corresponding backend endpoints.
		 *
		 * @param {number} status Target status id
		 * @return {string|null} Endpoint path or null if status is unsupported
		 */
		getPayslipStatusEndpoint(status) {
			if (status === this.approveStatus) {
				return '/payslip/approve';
			}
			if (status === this.rejectStatus) {
				return '/payslip/reject';
			}
			if (status === this.paidStatus) {
				return '/payslip/paid';
			}
			return null;
		}
	},

	mounted() {
		this.isLoading = true;
		this.getPayslips();
	},
};
